import { IPrescriptionService } from "../../core/impl/prescriptionServiceImpl";

export type IPrescriptionController = ReturnType<
  typeof PrescriptionControllerFactory
>;

export const PrescriptionControllerFactory = ({
  prescriptionService,
}: {
  prescriptionService: IPrescriptionService;
}) => {
  return {
    getPrescriptions: prescriptionService.getPrescriptions,
    getPrescriptionById: prescriptionService.getPrescriptionById,
    uploadPrescription: prescriptionService.uploadPrescription,
    deletePrescription: prescriptionService.deletePrescription,
  };
};
